import { render, staticRenderFns } from "./DialogModal.vue?vue&type=template&id=672d0170&"
import script from "./DialogModal.vue?vue&type=script&lang=ts&"
export * from "./DialogModal.vue?vue&type=script&lang=ts&"
import style0 from "./DialogModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports